import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabIndex } from '../tab-index.model';

@Component({
  selector: 'vti-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  public name = input.required<string>();
  public index = input.required<TabIndex>();

  @ViewChild(TemplateRef) public template!: TemplateRef<any>;
}
